module.exports = __webpack_public_path__ + "2752f86b2211d29e6e16f113bfefe536.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/heart.svg
// module id = 181
// module chunks = 0